var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sentence-swapper"},[_c('div',{staticClass:"slider-frame"},[_c('div',{staticClass:"slides",style:(_vm.slideStyle)},_vm._l((_vm.sentences),function(sentence,index){return _c('div',{key:index,staticClass:"slide"},[_vm._v("\n        "+_vm._s(sentence)+"\n      ")])}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }